import { Control, useWatch } from "react-hook-form";

import type { EmailBrandingKind } from "services/types/email-branding.type";
import { normalizeTemplateValue } from "utils/message-templates.util";

import EmailBrandingNotice from "./email-branding-notice.component";

interface EmailBrandingFormNoticeProps {
  // The hosting forms have unrelated value types; only `bodyName` is read.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  /** The form field holding the classic editor's body, previewed as the template would be saved. */
  bodyName: string;
  /** "any": a reusable template, which has no kind until it is sent, so it has no Preview. */
  kind: EmailBrandingKind | "any" | undefined;
  isDesigner: boolean;
  messageType?: number;
}

/**
 * EmailBrandingNotice under an editor bound to a react-hook-form field. Watching the body here, not
 * in the host, re-renders only this banner on each keystroke.
 */
export default function EmailBrandingFormNotice({
  control,
  bodyName,
  kind,
  isDesigner,
  messageType
}: EmailBrandingFormNoticeProps) {
  const body = useWatch({ control, name: bodyName });

  return (
    <EmailBrandingNotice
      kind={kind}
      isDesigner={isDesigner}
      getPreviewRequest={
        kind === "any"
          ? undefined
          : () => ({
              // Keep the HTML, which every host saves: stripping the tags also drops the editor's
              // <div> line breaks, so the preview ran every paragraph together (DEV-3473).
              html: normalizeTemplateValue(body, false) ?? "",
              branding_kind: kind ?? null,
              message_type: messageType ?? null
            })
      }
    />
  );
}
